import Image from "next/image";
import { useRouter } from "next/router";
import { Col, Row } from "react-bootstrap";
import styles from "./index.module.scss";
import { handleImage } from "../../handlers";
import { getId } from "../../helpers/functions";
import Link from "next/link";

export default function Countries({ data, page = "" }) {
  const { locale } = useRouter();

  return (
    <div className={`${styles.partners} wrapper ${page} w-100`}>
      <Row className="w-100 m-0">
        {data?.items?.map((item, index) => (
          <Col xxl={2} lg={3} md={4} sm={6} xs={12} key={"country" + index}>
            <div className="item">
              <Link
                href={`/recruitmentCountries/${getId(item)}`}
                legacyBehavior
              >
                <a></a>
              </Link>
              <Image
                src={handleImage(item?.image)}
                height={71}
                width={71}
                alt=""
              />
              <p>{item?.name?.[locale]}</p>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}
